var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"copy-button"},[_c('icon',{staticClass:"copy-button__icon",attrs:{"name":_vm.isShowCopiedIcon ? 'checkbox-circle' : 'copy'},nativeOn:{"click":function($event){return _vm.copyLink(_vm.copyValue)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }